<template>
  <div class="main">
    <div id="listview">
      <div v-for="item in items" :key="item.text" class="card">
        <div class="card-body" v-on:click="toDetails(item)">
          <p class="card-text">{{ item[1] }}<br><small class="text-muted pull-right">{{ item[9] }}</small></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sx from '../utils/core.js'
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  created() {
    this.$store.state.title = 'お知らせ'
    this.$store.state.pageBack = 'Notice'
  },
  data() {
    return {
      items: [],
      searchOpt: {
        kbn: '00',
        category: '20'
      }
    }
  },
  mounted() {
    $('#navbarSupportedContent').collapse({
      toggle: false
    }).collapse('hide')
    sx.showWaiting()
    const that = this

    var params = {
      bucketid: '17',
      options: JSON.stringify(that.searchOpt),
      token: localStorage.getItem('token') || 'token'
    }
    var url = that.$store.state.baseurl + '/app/cmshelper/fetchPostList'
    sx.request(
      url,
      params,
      function (result) {
        if (result.status === 'ok') {
          that.items = result.data.rows
          sx.hideWaiting()
        } else {
          sx.toastError(result.message)
          console.log(result.message)
        }
      },
      function () {
        sx.login(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              that.items = result.data.rows
              sx.hideWaiting()
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
            }
          }
        )
      }
    )
  },
  methods: {
    toDetails(item) {
      localStorage.setItem('itemDetails', JSON.stringify(item))
      this.$router.replace({ name: 'Details' })
    }
  }
}
</script>
<style>
#listview {
  margin: 4px;
}

#listview .card {
  text-align: left;
  margin-top: 6px;
}

#listview .card .card-body {
  padding: 10px;
}

small {
  color: #fb6e14;
}

.lead {
  padding-top: 20px;
  text-align: left;
  color: #fb6e14;
}

.main {
  padding: 4px;
}</style>
